import { Layout, Spin } from "antd";
import { useRoutes } from "react-router-dom";
import { useState, useLayoutEffect } from "react";

// File Imports --
import Login from "../auth/Login";
import Drawer from "../inc/Drawer";
import "../../App.css";
import LS_SERVICE from "../../utils/localStorage";
import { postAPI } from "../../utils/common";
import { USER_DETAIL } from "../../constants/api";
import RoutesList from "./Route";

const Base = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setIsLoading] = useState(true);

  // Fetch user data from API
  const getUserData = async () => {
    const data = new FormData();
    data.append("id", LS_SERVICE.get("id"));

    const successFn = (data) => {
      if (data.status === true) {
        LS_SERVICE.set("name", data.user.name);
        LS_SERVICE.set("user_type", data.user.user_type);
        LS_SERVICE.set("phone", data.user.phone);
        LS_SERVICE.set("email", data.user.email);
        LS_SERVICE.set("vendor_id", data.user?.vendor?.id);
        LS_SERVICE.set("hotel_id", data?.user?.vendor?.hotel_id);
        LS_SERVICE.set("referral_code", data?.user?.referral_code);
        LS_SERVICE.set("employee_code", data?.user?.employee_code);
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    };

    const errorFn = () => {
      setIsLoggedIn(false);
    };

    await postAPI(USER_DETAIL, data, successFn, errorFn);
  };

  // Fetch data on component mount
  useLayoutEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      if (LS_SERVICE.get("id") && LS_SERVICE.get("user_type") !== "customer") {
        await getUserData();
      }
      setIsLoading(false);
    };

    loadData();
  }, []);

  // Protected Route Component
  const ProtectedRoute = ({ children }) => {
    if (!isLoggedIn) {
      return <Login />; // Redirect to login if not logged in
    }
    return children;
  };

  // Define Routes outside of conditional hooks
  const routes = [
    {
      path: "/reservation/:start_date?/:end_date?/:adult_count?/:child_count?/:room_id?",
      element: null,
    }, // No sidebar for this route
    { path: "*", element: isLoggedIn ? <Drawer /> : null }, // Render sidebar for other routes
  ];

  const match = useRoutes(routes);

  if (loading) {
    return <Spin />; // Show loading spinner until the user data is fetched
  }

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f5f500" }}>
      {match}
      <RoutesList ProtectedRoute={ProtectedRoute} />
    </Layout>
  );
};

export default Base;
